import type { RouteObject } from "react-router-dom";
import PackingTasksList, { packingTasksLoader } from "./List";
import PackingVariancePage from "./Variance";
import PackingOverridesPage, { overridesLoader } from "./Overrides";
import SpotChecksPage, { spotChecksLoader } from "./SpotChecks";
import PackingCollisionsPage from "./Collisions";
import ToleranceRulesPage, { toleranceRulesLoader } from "./ToleranceRules";
import AppError from "../app-error";

/**
 * 005-packing-verification, admin-packing-oversight bucket (T053-T059, T066 admin portion). One
 * route table for the whole packing oversight section, same pattern as `orders/routes.tsx` —
 * imported once into `main.tsx`, nested under the root route's children so every screen here
 * inherits the permission guard (`rootLoader`) and the app shell.
 *
 * T066 (admin portion): every route names `AppError`, same as every other feature area's own
 * `errorElement`. `AppError` renders `ErrorSurface`, which already shows a problem document's
 * `title`/`detail` verbatim (constitution VI) — a second, packing-specific error boundary would
 * duplicate that component for no different behaviour. The states T066 actually names as *not*
 * failures — an empty list, a data-defect (unbandable) line — are each screen's own `EmptyState`/
 * inline copy above, never routed through `errorElement` at all.
 */
export const packingRoutes: RouteObject[] = [
  { path: "packing", Component: PackingTasksList, loader: packingTasksLoader, errorElement: <AppError /> },
  { path: "packing/variance", Component: PackingVariancePage, errorElement: <AppError /> },
  { path: "packing/overrides", Component: PackingOverridesPage, loader: overridesLoader, errorElement: <AppError /> },
  { path: "packing/spot-checks", Component: SpotChecksPage, loader: spotChecksLoader, errorElement: <AppError /> },
  { path: "packing/collisions", Component: PackingCollisionsPage, errorElement: <AppError /> },
  { path: "packing/tolerance-rules", Component: ToleranceRulesPage, loader: toleranceRulesLoader, errorElement: <AppError /> },
];
